<template>
  <el-dialog
    :visible.sync="dialogVisible"
    :show-close="false"
    width="320px"
    custom-class="customer-qr-dialog"
    :close-on-click-modal="true"
    append-to-body
  >
    <div class="qr-dialog-content">
      <!-- 关闭按钮 -->
      <div class="close-btn" @click="handleClose">
        <i class="el-icon-close"></i>
      </div>

      <div class="qr-container">
        <h2 class="title">添加客服微信咨询</h2>
        <div class="qr-white-box">
          <el-image
            v-if="customerConfig.customerImageUrl"
            :src="customerConfig.customerImageUrl"
            class="qr-image"
            fit="contain"
          >
            <div slot="placeholder" class="image-slot">
              加载中<span class="dot">...</span>
            </div>
          </el-image>
          <div v-else class="image-slot">暂无二维码</div>
        </div>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "CustomerQRDialog",
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapGetters(["customerConfig"]),
    dialogVisible: {
      get() {
        return this.visible;
      },
      set(val) {
        this.$emit("update:visible", val);
      },
    },
  },
  methods: {
    handleClose() {
      this.dialogVisible = false;
      this.$emit("close");
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep .customer-qr-dialog {
  background: transparent !important;
  box-shadow: none !important;
  margin-top: 15vh !important;

  .el-dialog__header {
    display: none;
  }

  .el-dialog__body {
    padding: 0;
    background: transparent;
  }
}

.qr-dialog-content {
  position: relative;
  width: 100%;
  padding-top: 20px;

  .close-btn {
    position: absolute;
    top: 25px;
    right: 5px;
    width: 24px;
    height: 24px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    z-index: 10;
    transition: all 0.3s;

    i {
      color: #fff;
      font-size: 18px;
      font-weight: bold;
    }

    &:hover {
      transform: rotate(90deg);
      opacity: 0.8;
    }
  }

  .qr-container {
    width: 100%;
    height: 380px;
    background: linear-gradient(180deg, #1e90ff 0%, #00d1bb 100%);
    border-radius: 16px;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 40px 20px 20px;
    box-sizing: border-box;

    .title {
      color: #fff;
      font-size: 20px;
      font-weight: 500;
      margin: 0 0 30px 0;
      letter-spacing: 1px;
    }

    .qr-white-box {
      width: 240px;
      height: 240px;
      background: #fff;
      border-radius: 16px;
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 15px;
      box-sizing: border-box;
      box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);

      .qr-image {
        width: 100%;
        height: 100%;
      }

      .image-slot {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 100%;
        height: 100%;
        color: #999;
        font-size: 14px;
      }
    }
  }
}
</style>
